import React from 'react'
import * as Bs from 'react-bootstrap'
import * as Bsr from 'react-router-bootstrap'
import { Link } from 'react-router'
import Icon from './icon'
import icons from '../../config/icons.json'
import TopTooltip from './topTooltip'
import FeedbackModal from './feedbackModal'
import getGravatarUrl from '_/utils/getGravatarUrl'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'

/**
 * Bottom navigation component
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class BottomNav extends React.Component {
  static propTypes = {
    account: React.PropTypes.object.isRequired,
    path: React.PropTypes.string
  }

  static contextTypes = {
    store: React.PropTypes.object
  }

  showFeedbackModal() {
    this.refs.feedback.showWindow()
  }

  render() {
    const { account, path } = this.props
    const photo = getGravatarUrl(account.get('email'), 80)
    const isGroupAdmin = account.get('isGroupAdmin')
    const isAcctCredPath = path === '/account/credit'

    return (
      <Bs.Navbar fixedBottom fluid>
        <div className="navbar-header">
            <Link to="my-account">
              <img
                className="img-circle"
                src={photo}
                style={{height: 40, marginLeft: 10, marginTop: 5}} />
            </Link>
            <Bs.Label bsStyle="success">{account.get('reputation')}</Bs.Label>
        </div>
        <Bs.Nav>
          <Bsr.NavItemLink to="my-account">My account</Bsr.NavItemLink>
          {isGroupAdmin && <Bsr.NavItemLink to="manage-group">Manage group</Bsr.NavItemLink>}
        </Bs.Nav>
        <Bs.Nav right>
          {account.getIn(['group', 'points']) != null && <Bs.NavItem><Icon name={icons.point} /> <b>{account.getIn(['group','points'])}</b></Bs.NavItem>}
          <Bsr.NavItemLink to={isGroupAdmin ? 'purchase-credits' : 'my-account'} active={isAcctCredPath}>
            <TopTooltip content="Available credits">
              <div>
                <Icon name={icons.credit} /> <b>{account.getIn(['group','credits'])}</b>
              </div>
            </TopTooltip>
          </Bsr.NavItemLink>
          <Bsr.NavItemLink to="my-account" active={false}>
            <Icon name={icons.group} /> <b>{account.getIn(['group','name'])}</b>: {account.getIn(['group','metro','name'])}
          </Bsr.NavItemLink>
          <Bs.NavItem onClick={::this.showFeedbackModal}>
            <TopTooltip content="Send feedback">
              <Icon name={icons.feedback} />
            </TopTooltip>
          </Bs.NavItem>
          {account.get('isAdmin') && <Bs.NavItem href="/settings"><Icon name={icons.admin}/></Bs.NavItem>}
          <Bs.NavItem href="/logout">
            <TopTooltip content="Sign out">
              <Icon name={icons.logout} />
            </TopTooltip>
          </Bs.NavItem>
        </Bs.Nav>
        <FeedbackModal ref="feedback" account={account} />
      </Bs.Navbar>
    )
  }
}

export default BottomNav



// WEBPACK FOOTER //
// ./modules/shared/components/bottomNav.js